import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { GroupsUsersService } from './service/groups-users.service';

export interface AllGroups {
	permission?: string;
	distinguishedName?: string;
	usertype?: string;
	description?: string;
	customer?: number;
	full_name?: string;
	email?: string;
	selected?: boolean;
	sort_order?: number;
}

@Component({
	selector: 'register-form-groups-users',
	templateUrl: './groups-users.component.html',
	styleUrls: ['./groups-users.component.scss'],
})
export class GroupsUsersComponent implements OnInit {
	selectedGroup = '';
	selectedUsertype = '';
	searchText: string;
	dragIndex: number;

	showTableEnduser = false;

	isLoadingPermissionData = true;
	isLoadingLabels = true;
	isLoadingData = true;

	labels: any = {
		lbl_geral_selecione: 'Select',
		lbl_campos_filtro: 'Fill in the fields marked with * and select a filter',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_geral_deletado_com_sucesso: 'Successfully deleted',
		lbl_erro_nome_selecionado: 'ERROR: The selected name exists',
		lbl_geral_pesquisar: 'Search',
		lbl_geral_groups_users: 'Groups and Users',
		lbl_geral_groups_ad: 'AD Groups',
		lbl_geral_tipo_usuario: 'Enduser Type',
		lbl_geral_permissoes: 'Access Permissions',
		lbl_geral_grupos: 'Solution Areas',
		lbl_cadastro_permissoes: 'Permissions',
		lbl_geral_nome: 'Name',
		lbl_cmdb_email: 'E-mail',
		lbl_geral_atualizar: 'Update',
		lbl_geral_excluir: 'Delete',
		lbl_geral_group_permission: 'Please select a permission group',
		lbl_geral_groups_permissions: 'Permission Groups',
		lbl_geral_group_permission_creation: 'Permission group creation',
		lbl_rep_ordem: 'Presentation Order',
		lbl_geral_sorted_successfully: 'Sorted successfully!',
		lbl_geral_select_permissions_group_to_link: 'Select a permissions group to link it to this AD group',
		lbl_geral_verification_order: 'Verification Order',
		lbl_geral_no_register_usertype_groups: 'There are no registered users for this AD group and permission group',
	};

	groupsList: AllGroups[] = [];
	groupsSearchList: AllGroups[] = [];
	endusersList: AllGroups[] = [];
	usertypeList: AllGroups[] = [];
	groupAdList: AllGroups[] = [];
	allGroupsList: AllGroups[] = [];
	groupListDrag: AllGroups[] = [];

	allListPermissions: AllGroups[] = [];
	searchListPermissions: AllGroups[] = [];

	customInterface: AllGroups = {
		permission: '',
		description: '',
		distinguishedName: '',
		usertype: '',
		full_name: '',
		email: '',
	};

	constructor(
		private GroupsUsersService: GroupsUsersService,
		private notification: NotificationService,
		private labelsService: LabelsService
	) {}

	selectedTab = 'group_users';

	ngOnInit() {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.GroupsUsersService.getSearchUsertype()
			.subscribe((listUsertype) => {
				this.usertypeList = listUsertype;
				this.usertypeList.sort((a, b) => {
					if (a.usertype.toString() > b.usertype.toString()) return 1;
					if (a.usertype.toString() < b.usertype.toString()) return -1;
					return 0;
				});
			})
			.add(() => {
				this.isLoadingPermissionData = false;
				this.isLoadingData = false;
			});

		this.GroupsUsersService.getSearchGroupAd()
			.subscribe((listGroupAd) => {
				this.groupAdList = listGroupAd;
			})
			.add(() => {
				this.isLoadingPermissionData = false;
			});

		this.GroupsUsersService.getSearchPermissions().subscribe((listPermissions) => {
			this.allListPermissions = listPermissions;
			this.searchListPermissions = [...listPermissions];
		});

		this.GroupsUsersService.getGroupSortOrder().subscribe((listGroupSortOrder) => {
			this.groupListDrag = listGroupSortOrder;
		});
	}

	// onUsertypeChange(event: any): void {
	//   if (event.target.value === '') {
	//     this.endusersList = [];
	//     this.showTableEnduser = false;

	//   } else {
	//     this.selectedUsertype = event.target.value;
	//     this.loadPermissionView(this.selectedUsertype);
	//   }
	// }

	onGroupsChange(event: any): void {
		this.selectedGroup = event.target.value;
		if (this.selectedGroup === '') {
			this.selectedUsertype = '';
			this.showTableEnduser = false;
			return;
		}

		const selectGroupObject = this.groupAdList.find((element) => element.distinguishedName === this.selectedGroup);
		if (selectGroupObject) {
			this.selectedUsertype = selectGroupObject.usertype;
			this.loadPermissionView(this.selectedUsertype);
		}
	}

	loadPermissionView(value: string): void {
		if (value === '') {
			this.notification.setNotificationMessage(this.labels.lbl_geral_select_permissions_group_to_link);
			this.showTableEnduser = false;
		} else {
			this.GroupsUsersService.getAllEndusersGroups(value)
				.subscribe((enduser) => {
					this.endusersList = enduser;
					this.groupsList = [...enduser];
				})
				.add(() => {
					if (this.endusersList.length > 0) {
						this.showTableEnduser = true;
					} else {
						this.showTableEnduser = false;
						this.notification.setNotificationMessage(this.labels.lbl_geral_no_register_usertype_groups);
					}
				});
		}
	}

	searchItemsEndusers() {
		this.endusersList =
			this.searchText === ''
				? [...this.groupsList]
				: this.endusersList.filter((item) => {
						return (
							item.full_name.toLowerCase().includes(this.searchText.toLowerCase()) ||
							item.email.toLowerCase().includes(this.searchText.toLowerCase())
						);
					});
	}

	saveGroupAndPermission() {
		if (this.selectedGroup === '' || this.selectedUsertype === '') {
			return this.notification.setNotificationMessage(this.labels.lbl_campos_filtro);
		}
		this.GroupsUsersService.saveGroupAndPermission(this.selectedGroup, this.selectedUsertype)
			.subscribe(() => {
				this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.selectedGroup = '';
				this.selectedUsertype = '';
			})
			.add(() => {
				this.GroupsUsersService.getGroupSortOrder().subscribe((listGroupSortOrder) => {
					this.groupListDrag = listGroupSortOrder;
				});
				this.GroupsUsersService.getSearchGroupAd().subscribe((listGroupAd) => {
					this.groupAdList = listGroupAd;
				});
			});
	}

	updateSortOrder() {
		const payload = this.groupListDrag.map((item: any, index: number) => ({
			distinguishedName: item.distinguishedName,
			sort_order: index + 1,
		}));
		this.GroupsUsersService.updateSortOrder(payload).subscribe(() => {
			this.notification.setNotificationMessage(this.labels.lbl_geral_sorted_successfully);
		});
	}

	onDragStart(event: DragEvent, index: number) {
		this.dragIndex = index;
		event.dataTransfer!.setData('text/plain', 'Dragging');
	}

	onDragOver(event: DragEvent, index: number) {
		event.preventDefault();
	}

	onDrop(event: DragEvent, index: number) {
		event.preventDefault();
		const draggedItem = this.groupListDrag[this.dragIndex];
		this.groupListDrag.splice(this.dragIndex, 1);
		this.groupListDrag.splice(index, 0, draggedItem);
	}

	onDragEnd() {
		this.dragIndex = -1;
	}
}
